export const getPersistedFormData = form => JSON.parse(sessionStorage.getItem(form) || '{}');
export const persistInputData = (form, inputId) => value => {
  const persistedFormData = getPersistedFormData(form);
  sessionStorage.setItem(form, JSON.stringify({
    ...persistedFormData,
    [inputId]: value
  }));
};
//# sourceMappingURL=persistence.js.map